import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Colors,
  Icons,
  Typography,
  createClasses,
  spacing,
} from '@kp/react-ui';

import { KpiCard, type KpiCardProps } from './KpiCard';
import { KpiCardHeader } from './KpiCardHeader';

const classes = createClasses({
  valueRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing('xs'),
  },
  inactive: {
    color: Colors.Neutral.textInactive,
  },
});

export interface InstallationsCardProps
  extends Pick<
    KpiCardProps,
    'href' | 'isLoading' | 'isError' | 'isEmpty' | 'onRetry' | 'className'
  > {
  percent: string;
  underperforming: number;
  total: number;
}

export const InstallationsCard: React.FC<InstallationsCardProps> = ({
  percent,
  underperforming,
  total,
  ...cardProps
}) => {
  const { t } = useTranslation();
  const title = t('home.installations.title');

  return (
    <KpiCard
      header={
        <KpiCardHeader
          icon={Icons.IconUtilities}
          title={title}
          subtitle={t('home.installations.subtitle')}
        />
      }
      linkLabel={t('home.openIn', { section: title })}
      {...cardProps}
    >
      <div className={classes.valueRow}>
        <Typography variant="headlineMedium">{percent}</Typography>
        <Typography variant="bodySmall" className={classes.inactive}>
          %
        </Typography>
      </div>
      <Typography variant="bodySmall" className={classes.inactive}>
        {t('home.installations.underperforming', {
          count: underperforming,
          total,
        })}
      </Typography>
    </KpiCard>
  );
};
